import "@/App.css";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { CartProvider } from "@/lib/cart";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/shop/Header";
import { Footer, WhatsAppFab } from "@/components/shop/Footer";
import { CartSheet } from "@/components/shop/CartSheet";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import Payment from "@/pages/Payment";
import Track from "@/pages/Track";
import { MyOrders, SignInPage, SignUpPage } from "@/pages/Account";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import ProductEditor from "@/pages/admin/ProductEditor";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminShipping from "@/pages/admin/AdminShipping";
import AdminReports from "@/pages/admin/AdminReports";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminAccount from "@/pages/admin/AdminAccount";

const ShopLayout = () => (
  <div className="flex min-h-screen flex-col">
    <Header />
    <main className="flex-1"><Outlet /></main>
    <Footer />
    <WhatsAppFab />
    <CartSheet />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <CartProvider>
          <Routes>
            <Route element={<ShopLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/produk/:id" element={<ProductDetail />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/bayar/:orderId" element={<Payment />} />
              <Route path="/lacak" element={<Track />} />
              <Route path="/pesanan-saya" element={<MyOrders />} />
              <Route path="/sign-in/*" element={<SignInPage />} />
              <Route path="/sign-up/*" element={<SignUpPage />} />
            </Route>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="produk" element={<AdminProducts />} />
              <Route path="produk/baru" element={<ProductEditor key="new" />} />
              <Route path="produk/:id" element={<ProductEditor />} />
              <Route path="kategori" element={<AdminCategories />} />
              <Route path="pesanan" element={<AdminOrders />} />
              <Route path="tarif" element={<AdminShipping section="tarif" />} />
              <Route path="pajak" element={<AdminShipping section="pajak" />} />
              <Route path="toko" element={<AdminShipping section="toko" />} />
              <Route path="ongkir" element={<Navigate to="/admin/tarif" replace />} />
              <Route path="akun/*" element={<AdminAccount />} />
              <Route path="laporan" element={<AdminReports />} />
              <Route path="pengguna" element={<AdminUsers />} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors />
        </CartProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
